module.exports = __webpack_public_path__ + "img/266.product_show.3799d69d.svg";